import { useTranslations } from '@vocab/react';
import { Loader, Text } from 'braid-design-system';
import type React from 'react';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { PREFERRED_LOCATIONS } from 'src/components/Router';
import { NEXT_ROLE_PREFERRED_LOCATION_FORM } from 'src/reducers/forms';
import type { Location2 } from 'src/types/graphql';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditPreferredLocation } from '../EditPreferredLocation/EditPreferredLocation';
import { GroupedPreferredLocations } from '../GroupedPreferredLocations';
import { usePreferredLocations } from '../data';

import translations from './.vocab';

export const ReadPreferredLocation = () => {
  const { t } = useTranslations(translations);

  const { preferredLocations, error } = usePreferredLocations();

  const locationItem = (location: Location2): React.ReactElement => (
    <Text key={location.shortDescription}>{location.shortDescription}</Text>
  );

  return (
    <>
      <NextRoleDetail
        title={t('Preferred locations')}
        section={NextRoleSection.preferredLocations}
      >
        {error ? (
          <Loader data={{ automation: 'preferred-locations-loading' }} />
        ) : (
          preferredLocations.length > 0 && (
            <GroupedPreferredLocations
              preferredLocations={preferredLocations}
              locationItem={locationItem}
              dataAutomationSuffix="read"
            />
          )
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Preferred locations')}
        component={EditPreferredLocation}
        card={PREFERRED_LOCATIONS}
        formName={NEXT_ROLE_PREFERRED_LOCATION_FORM}
        description={t(
          'Let employers know about your preferred work locations.',
        )}
      />
    </>
  );
};
